module.exports = __webpack_public_path__ + "static/flags/FO-caad63e7b5af240a4e4ef2fa794d8efe.gif";